import { cloneImmutableArray } from './cloneImmutableArray';

export const arrayMove = <T>(arr: T[], previousIndex: number, newIndex: number): T[] => {
    const array = cloneImmutableArray(arr);

    array.splice(newIndex, 0, array.splice(previousIndex, 1)[0]);

    return array;
};
